define(function(require,exports,module) {
    var Config = require("../../Config/Config");
    var comment = {
        init: function(arg) {
            var self = this;
            self.ajaxComment(arg);
        },
        getCommentSku: function() {
            var skuList = "";
            $(".hasComment").each(function() {
                var skuid = $.trim($(this).attr("skuid"));
                skuid = skuid.substring(2, skuid.length);  
                skuList += "," + skuid;
            });
            skuList = skuList.substring(1, skuList.length);
            return skuList;
        },
        ajaxComment: function(arg) {
            var self = this;
            var skuList = self.getCommentSku();
            if(skuList == "") {
                return false;
            }
            $.ajax({
                url: Config.serviceInterface.getCommentByskuIds,
                data: {
                    "skuids": skuList
                },
                method: 'get',
                dataType: 'jsonp',
                success: function(data) {
                    for(var i=0; i<data.length; i++) {
                        var id = "J_" + data[i].id;
                        var count = data[i].count;
                        if(count >= 10000){
                            if(count >= 100000){
                                count = parseInt(count/10000) + '万+'
                            }else{
                                count = parseInt(count/1000)/10 + '万+'
                            }
                        }else if(count >= 100 && count < 10000){
                            count = parseInt(count/100) + '00+'
                        }else if(count >= 10 && count < 100){
                            count = parseInt(count/10) + '0+'
                        }else if(count > 0){
                            count = count
                        }else{
                            count = '0'
                        }

                        $(".hasComment").each(function() {
                            if($(this).attr("skuid") == id) {
                                if(arg && arg == "indexV2") {
                                    $(this).find(".comment").append('<span class="cNum"><b class="comment_num">' + count + '</b> 条评价</span>');
                                } else {
                                    //$(this).find(".comment").html("<i></i><span>" + count + "</span>");
                                    $(this).find(".comment").html('<span class="cNum"><b class="comment_num">' + count + '</b> 条评价</span>');
                                }
                            }
                        });
                    }
                }
            });
        }
    };
    exports.fn = comment;
});


// WEBPACK FOOTER //
// ./src/js/unit/comment/comment.js